import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TextareaAutosize from 'react-autosize-textarea';
import './ShortDescription.scss';
var breakSentence = /\b(\w|\w+[^\w\s]*\w+)\b/g;
var ShortDescription = /*#__PURE__*/function (_Component) {
  function ShortDescription(props) {
    var _this;
    _classCallCheck(this, ShortDescription);
    _this = _callSuper(this, ShortDescription, [props]);
    var text = props.text;
    _this.state = {
      text: text
    };
    _this.handleChange = _this.handleChange.bind(_this);
    return _this;
  }
  _inherits(ShortDescription, _Component);
  return _createClass(ShortDescription, [{
    key: "handleChange",
    value: function handleChange(event) {
      var text = event.target.value;
      this.setState({
        text: text
      });
    }
  }, {
    key: "countWords",
    value: function countWords() {
      var text = this.state.text;
      var wordsCount = text.match(breakSentence) || [];
      return wordsCount.length;
    }
  }, {
    key: "render",
    value: function render() {
      var text = this.state.text;
      var wordsCount = this.countWords();
      var passedFifty = wordsCount > 50;
      var wordsText = passedFifty ? wordsCount : 50 - wordsCount;
      return /*#__PURE__*/React.createElement("div", {
        className: "form-group mt-4"
      }, /*#__PURE__*/React.createElement("label", {
        className: "g-flex-fill",
        htmlFor: "project_short_description"
      }, /*#__PURE__*/React.createElement("span", {
        className: "required"
      }, "Please tell us about your project and product."), /*#__PURE__*/React.createElement("a", {
        className: "ms-2 small-text",
        "data-bs-toggle": "modal",
        "data-bs-target": "#exampleProjectModal"
      }, "See example"), /*#__PURE__*/React.createElement("div", {
        className: "small-text normal-font"
      }, "The more detailed you are, the faster we can find you the perfect consultant!")), /*#__PURE__*/React.createElement(TextareaAutosize, {
        className: "form-control form-control--light",
        name: "project[short_description]",
        id: "project_short_description",
        rows: 4,
        placeholder: "We recommend a maximum of 50 words",
        onChange: this.handleChange,
        value: text,
        required: "required"
      }), /*#__PURE__*/React.createElement("div", {
        className: "wordsContainer".concat(passedFifty ? ' redish' : '')
      }, wordsText, ' ', wordsText === 1 ? 'word' : 'words'));
    }
  }]);
}(Component);
ShortDescription.propTypes = {
  text: PropTypes.string
};
ShortDescription.defaultProps = {
  text: ''
};
export default ShortDescription;